export const INIT_CARD = {
  id: null,
  group: 0,
  page: 0,
  word: 'breakfast',
  image: 'files/01_0005.jpg',
  wordTranslate: ' ',
};
